import { Route, RouteComponentProps, Switch } from "react-router";

import AccessIntelSecuredPage from "Views/Components/Security/AccessIntelSecuredPage";
import { CreditReportList } from "Views/Components/CreditReport/CreditReportList";
import { GenerateCreditReport } from "Views/Components/CreditReport/GenerateCreditReport";
import HandleEvents from "Util/HandleEvents";
import { PageBreadcrumbs } from "Views/Components/Breadcrumbs/PageBreadcrumbs";
import classNames from "classnames";
import { store } from "Models/Store";

const Tags = [
	{ label: 'Credit Reports' },
]
export interface CreditReportPageProps extends RouteComponentProps { }
const CreditReportPage = (props: CreditReportPageProps) => {
	const { match, location } = props;
	const { path } = match;

	return (
		<AccessIntelSecuredPage routeComponentProps={props}>
			<div className="body-content list-page">
				<div className="top-container">
					<PageBreadcrumbs tags={Tags} />
				</div>

				<div className="tab-selector-wrap">
					<button
						className={classNames('tab-selector', 'credit-reports', {
							active: !location.pathname.includes('history')
						})}
						{...HandleEvents(() => {
							store.routerHistory.push('/hub/credit-reports');
						})}
					>
						Reporting
					</button>
				</div>
				<div className={classNames('white-box')}>
					<Switch>
						<Route
							path={`${path}/history`}
							component={() => (
								<p>Credit Report History Component</p>
							)}
						/>
						<Route
							path={`${path}/generate`}
							component={() => (<GenerateCreditReport />)}
						/>
						<Route
							path="/"
							component={() => <CreditReportList />}
						/>
					</Switch>
				</div>
			</div>
		</AccessIntelSecuredPage>
	);
};

export default CreditReportPage;